<template>
  <main class="main" style="background-color: white;min-height: calc(100vh - 60px);overflow: hidden;">
    <portal to="headerTitle">
      Access Control
    </portal>
    <template v-if="token !== null && $route.name === 'interfaces.locking.devices'">
      <hm-col v-if="!isNil(token)" cols="12">
        <seam-device-table :client-session-token="token" />
      </hm-col>
    </template>
    <template v-if="iframeUrl !== null && $route.name === 'interfaces.locking.portal'">
      <hm-col cols="12">
        <iframe :src="iframeUrl" style="border: none!important;width:100%;height: calc(100vh - 60px - 60px)" allow="clipboard-write;" @load="showSpinner = false;" />
      </hm-col>
    </template>
    <spinner-overlay v-if="showSpinner" />
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil } from 'lodash';
import HmCardInner from '../../../lib/layout/HmCardInner';
import TimerMixin from '../../../../mixins/TimerMixin';
// import '@seamapi/react/dist/elements';

export default {
  name: 'PageLockingSeamIframe',
  components: { HmCardInner },
  mixins: [HotelmeisterMixin, TimerMixin],

  data() {
    return {
      token: null,
      iframeUrl: null,
      showSpinner: true,
    };
  },

  computed: {
  },

  watch: {
    token: function (newVal) {
      if (this.$route.name === 'interfaces.locking.devices') {
        if (isNil(newVal)) this.showSpinner = true;
        else this.setTimeout(() => { this.showSpinner = false; }, 2500);
      }
    },
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isNil,
    loadData() {
      switch (this.$route.name) {
        case 'interfaces.locking.devices':
          this.axios.get(this.serviceUrls.interfaces.locking.seam.session(this, this.$route.params.interfaceId))
            .then((response) => {
              this.token = response.data.data.token;
            })
            .catch((error) => {
              if (isNil(error.response)) this.showErrorMessage();
              this.showMessages(error.response);
            });
          break;
        case 'interfaces.locking.portal':
          this.iframeUrl = this.$route.params.iframeUrl;
          break;
        default:
          // do nothing, should not happen
          break;
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageLockingSeamIframe.vue